import * as types from "../../Action/actionTypes";

const initialState = {
  loading: false,
  error: null,
  corporateData: {},
  success: false,
};

const corporateSignupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUBMIT_CORPORATE_STEP:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case types.SUBMIT_CORPORATE_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        corporateData: { ...state.corporateData, ...action.payload },
        success: true,
      };
    case types.SUBMIT_CORPORATE_STEP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    default:
      return state;
  }
};

export default corporateSignupReducer;
